import React from 'react';
import { getFileName } from '@Actions/documentActions';
import ConfigComponent from './components/Config';
import { calculateOverflow } from '@Utils/commonUtils';
class SettingsContainer extends React.Component {
    static navigateToLoadingPage(history) {
        history.push('/loading');
        calculateOverflow('loading');
    }

    constructor(props) {
        super(props);
        const { isSignedIn } = this.props;

        this.state = {
            currentFilename: '',
            // eslint-disable-next-line react/no-unused-state
            isSignedInState: isSignedIn
        };
    }

    componentDidMount() {
        getFileName().then(res => this.setState({ currentFilename: res }));
    }

    componentDidUpdate = prevProps => {
        const { isSignedIn } = this.props;
        const { isSignedIn: pervIsSignedIn } = prevProps;

        if (isSignedIn !== pervIsSignedIn) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                // eslint-disable-next-line react/no-unused-state
                isSignedInState: isSignedIn
            });
        }
    };

    static getDerivedStateFromProps = (nextProps, prevState) => {
        const { history, isSignedIn } = nextProps;

        if (!prevState.isSignedInState) {
            if (isSignedIn) {
                this.navigateToLoadingPage(history);
            }
        }
        return null;
    };

    render() {
        const { currentFilename } = this.state;

        return (
            <>
                <ConfigComponent currentFilename={currentFilename} />
            </>
        );
    }
}

export default SettingsContainer;
